import format from "date-fns/format";

export const getCompletedPeriod = (startDate: string, endDate: string) => {
  return `${format(new Date(startDate), "MMM d, yyyy")} - ${format(
    new Date(endDate),
    "MMM d, yyyy"
  )}`;
};

export const priceToFormat = (price: number, withSign?: boolean) => {
  const res = new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: "CAD",
  }).format(price);

  return `${withSign && price > 0 ? "+" : ""}${res}`;
};

export const getPercentFormat = (percent: number) => {
  return new Intl.NumberFormat("en-CA", {
    style: "percent",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(percent);
};

export const formatWeight = (weight?: number) => {
  if (!weight)
    return "";

  return (weight * 1000).toLocaleString("en-US", {minimumFractionDigits: 0, maximumFractionDigits: 2, useGrouping: true});
};

export const getHstTax = (
  total: number,
  hstTax: number,
  isHSTExemptChecked: boolean
) => (isHSTExemptChecked ? 0 : total * hstTax);

export const getAdjustmentValue = (total: number, enteredAdjustment?: number) =>
  enteredAdjustment != null ? enteredAdjustment - total : 0;
